var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 11.3332V11.9998C10.0001 13.1044 9.10465 13.9998 8.00008 13.9998C6.89551 13.9998 6.00008 13.1044 6.00008 11.9998V11.3332M10.0001 11.3332H6.00008M10.0001 11.3332H12.3938C12.6488 11.3332 12.7769 11.3332 12.8801 11.2983C13.0774 11.2318 13.2317 11.0769 13.2983 10.8797C13.3332 10.776 13.3332 10.6475 13.3332 10.3905C13.3332 10.278 13.3331 10.2218 13.3243 10.1681C13.3077 10.0668 13.2683 9.97073 13.2085 9.88731C13.1768 9.84324 13.1366 9.80301 13.0573 9.72372L12.7976 9.46403C12.7138 9.38024 12.6667 9.26659 12.6667 9.14811V6.6665C12.6667 4.08917 10.5774 1.99983 8.00008 1.99984C5.42276 1.99984 3.33341 4.08918 3.33341 6.6665V9.14812C3.33341 9.26662 3.28624 9.38024 3.20246 9.46403L2.94279 9.7237C2.86326 9.80323 2.82344 9.8432 2.79175 9.88734C2.73185 9.97075 2.69218 10.0668 2.67555 10.1681C2.66675 10.2218 2.66675 10.278 2.66675 10.3905C2.66675 10.6475 2.66675 10.776 2.70172 10.8797C2.76825 11.0769 2.92328 11.2318 3.12052 11.2983C3.22379 11.3332 3.35142 11.3332 3.60645 11.3332H6.00008M12.0125 1.34229C12.9319 2.03516 13.6563 2.95435 14.115 4.01033M3.98806 1.34229C3.06858 2.03516 2.34421 2.95435 1.8855 4.01033",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellRing);
export default __webpack_public_path__ + "static/media/Bell_Ring.b06d228f547b64959a29785569da15d9.svg";
export { ForwardRef as ReactComponent };